import { createContext, useContext, useEffect, useState } from 'react'
import { RenderRoutes } from '../components/structure/RenderNavigation'
import { useDispatch } from 'react-redux'
import { updateUserData } from '../redux/features/common/commonSlice'

const AuthContext = createContext()

export const AuthData = () => useContext(AuthContext)

export const AuthWrapper = () => {
  const dispatch = useDispatch()
  const [user, setUser] = useState({ name: '', isAuthenticated: false })

  // Check authentication status on mount
  useEffect(() => {
    const storeData = localStorage.getItem('userData')
    const token = localStorage.getItem('userToken')
    
    if (storeData && token) {
      try {
        const userData = JSON.parse(storeData)
        dispatch(updateUserData(userData))
        setUser({ name: userData?.userName, isAuthenticated: true })
      } catch (err) {
        console.error('Error parsing stored auth data:', err)
      }
    }
  }, [])

  const login = (userName, password) => {
    return new Promise((resolve, reject) => {
      setUser({ name: userName, isAuthenticated: true })
      resolve('success')
    })
  }

  const logout = () => {
    // Clear all auth-related items from localStorage
    localStorage.removeItem('userData')
    localStorage.removeItem('userToken')
    localStorage.removeItem('permissionId')
    localStorage.removeItem('rememberMe')
    localStorage.removeItem('rememberMeUserData')
    
    // Clear Redux state
    dispatch(updateUserData({}))
    setUser({ name: '', isAuthenticated: false })
    
    // Redirect to login while preserving the current URL in case we need to redirect back
    const currentPath = window.location.pathname
    if (currentPath !== '/login') {
      localStorage.setItem('redirectAfterLogin', currentPath)
    }
    window.location.href = '/login'
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <>
        <RenderRoutes />
      </>
    </AuthContext.Provider>
  )
}
